import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Lottie from 'lottie-react';
import { Button } from '../../shared/components/Buttons';
import { ButtonVariant } from '../../shared/components/Buttons/types';

interface ErrorPage403Props {
  onBack?: () => void;
}

const ErrorPage403 = ({ onBack }: ErrorPage403Props) => {
  const navigate = useNavigate();
  const [animationData, setAnimationData] = useState<object | null>(null);

  useEffect(() => {
    fetch('/assets/lottie/403LottieFile.json')
      .then((res) => res.json())
      .then((data) => setAnimationData(data))
      .catch(() => {});
  }, []);

  return (
    <div className="flex flex-1 flex-col items-center justify-center w-full h-full gap-8 bg-white rounded-[4px] shadow-[0px_2px_4px_0px_#00000014]">
      {animationData ? (
        <Lottie
          animationData={animationData}
          loop={false}
          style={{ width: '298px', height: '235px' }}
        />
      ) : (
        <div style={{ width: '298px', height: '235px' }} />
      )}
      <div className="flex flex-col items-center gap-2 text-center">
        <p className="text-titleMedium text-on-surface-variant font-semibold">
          403 – Access Denied
        </p>
        <p className="text-bodyLarge text-on-surface-variant max-w-sm">
          Looks like this page is restricted. If you think you should have
          access, try contacting your admin.
        </p>
      </div>
      <div className="flex gap-3">
        {onBack && (
          <Button
            className="cursor-pointer"
            label="Go Back"
            variant={ButtonVariant.Secondary}
            onClick={onBack}
          />
        )}
        <Button
          className="cursor-pointer"
          label="Go to Dashboard"
          onClick={() => navigate('/')}
        />
      </div>
    </div>
  );
};

export default ErrorPage403;
